import React, { useEffect, useState } from "react";
import BartendersList from "../components/bartenderList";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "@/components/DashboardHeader";
import { GET } from "../services/api";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import FormModal from "@/components/modals/FormModal";
import AddBartenderModal from "./Bartender/AddBartenderModal";
import { Loader } from "@thdinc/hpf-shared";

const Bartenders = () => {
  const [bartenderList, setBartenderList] = useState<Array<any>>([]);
  const navigate = useNavigate();

  const { refreshToken } = useAppSelector((store) => store.user);
  const { allBartenders } = API_ROUTES
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reRender,setReRender] = useState(false)
  const rerenderFun = ()=>{
    console.log('render',reRender)
    setReRender(!reRender)
  }
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    fetchData();
   
  }, [reRender]); // Empty dependency array to run effect only once on component mount

  const fetchData = async () => {
    // fetch the list of all the available barenders
    try {
      const result = await GET(allBartenders, refreshToken);
      setBartenderList(result?.data)
      setLoading(false)
    } catch (err) {
      setError(String(err));
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="  h-screen">

      <DashboardHeader title="Bartenders">
        <div className="flex justify-end w-full">
          {/* navigate for new bartender */}
          <button className="bg-black text-white  rounded-full py-2 px-6"   onClick={openModal}> <span className="text-lg">+</span> Add New</button>
        </div>
        <FormModal overflow="overflow-hidden " modalTitle="Add Bartender" isOpen={isModalOpen} width="lg:w-3/6 md:w-5/6 w-full" height="overflow-y-auto" onClose={closeModal} >
       <AddBartenderModal closeModal={closeModal} rerenderFun={rerenderFun}/>
      </FormModal>
      </DashboardHeader>


      {loading ? (
        <Loader />
      ) : (
        <div className="    ">
          <BartendersList data={bartenderList} />
        </div>
      )}
    </div>
  );
};

export default Bartenders;
